import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomText, { textStyles } from "../../components/CustomText";
import aboutheroimage from "../../assets/aboutheroimage.png";
import { useTranslation } from "react-i18next";

const Cookies = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const privacyData = [
    {
      title: "Information We Collect",
      content:
        "We collect various types of information to provide and improve our biometric time tracking services. Personal Information includes your name, email address, phone number, and company details when you create an account or contact us. We also gather Usage Data about how you interact with our services, including access times, pages viewed, and actions taken. Most importantly, we collect Biometric Data such as facial recognition data and other biometric identifiers used for time tracking and authentication purposes. Location Data including GPS coordinates is collected when using location-based features, and we gather Device Information about the devices used to access our services, including device type, operating system, and browser information.",
    },
    {
      title: "How We Use Your Information",
      content:
        "We use the collected information for several purposes essential to our service delivery. Primarily, we provide and maintain our time tracking and workforce management services, process transactions and manage your account effectively. The biometric data is used to authenticate users through biometric verification and track employee attendance and location for authorized business purposes. We continuously work to improve our services and develop new features based on usage patterns. Additionally, we use your information to communicate with you about service updates and provide customer support when needed. All data usage complies with legal obligations and helps us protect our rights and the security of our platform.",
    },
    {
      title: "Information Sharing and Disclosure",
      content:
        "We maintain strict policies regarding information sharing to protect your privacy. We do not sell, trade, or rent your personal information to third parties under any circumstances. However, we may share information with trusted service providers who assist in our operations and are bound by confidentiality agreements. Information may be disclosed when required by law, court orders, or to protect our rights and the rights of our users. In the event of business transfers such as mergers or acquisitions, your information may be transferred as part of the business assets. For any other purposes, we will only share information with your explicit consent and clear understanding of how it will be used.",
    },
    {
      title: "Data Security",
      content:
        "Protecting your data is our top priority, and we implement comprehensive security measures throughout our systems. We use industry-standard security protocols and regularly update our practices to address emerging threats. All data transmission is encrypted using SSL/TLS protocols to ensure secure communication. Biometric data receives special protection through advanced encryption and secure storage measures that exceed industry standards. Access to personal information is strictly restricted to authorized personnel who require it for their job functions. We maintain robust monitoring systems to detect and respond to potential security incidents, and in the unlikely event of a data breach, we commit to notifying affected users promptly and transparently.",
    },
    {
      title: "Data Retention",
      content:
        "Our data retention practices are designed to balance service functionality with privacy protection. We retain personal information only for as long as necessary to provide our services effectively and meet legal requirements. Account information is maintained until account deletion or as required by applicable laws and regulations. Biometric data is retained only for the duration of employment or service agreement and is securely deleted when no longer needed. Log data and usage information may be retained for up to 2 years for security analysis and service improvement purposes. Users have the right to request deletion of their personal data, subject to legal and contractual obligations that may require longer retention periods.",
    },
    {
      title: "Your Rights",
      content:
        "You have comprehensive rights regarding your personal information and how it's used. You can request access to copies of your personal information that we hold and process. If any information is inaccurate or incomplete, you have the right to request corrections. You may also request deletion of your personal information when it's no longer needed for the purposes it was collected. Data portability rights allow you to request transfer of your data to another service provider in a structured format. You can opt-out and withdraw consent for certain data processing activities at any time. Additionally, you have the right to request restriction of processing in certain circumstances, such as when you contest the accuracy of the data.",
    },
    {
      title: "Cookies and Tracking Technologies",
      content:
        "We use cookies and similar tracking technologies to enhance your user experience and improve our services. Essential cookies are necessary for basic website functionality and cannot be disabled without affecting core features. Analytics cookies help us understand how users interact with our services, allowing us to make data-driven improvements. You have full control over cookie preferences through your browser settings, where you can accept, reject, or manage cookies according to your preferences. Some third-party cookies may be used for integrated services and analytics, but these are carefully selected and managed to protect your privacy while providing enhanced functionality.",
    },
    {
      title: "International Data Transfers",
      content:
        "As a global service provider, your data may be processed and stored in countries other than your own to ensure optimal service delivery. We ensure that appropriate safeguards are in place for all international data transfers, maintaining the same level of protection regardless of location. All data transfers comply with applicable privacy laws and regulations, including GDPR and other international standards. We use standard contractual clauses, adequacy decisions, and other approved legal mechanisms to provide strong protection for your data. Our international partners and service providers are carefully vetted and must meet our strict privacy and security requirements.",
    },
    {
      title: "Children's Privacy",
      content:
        "Our biometric time tracking and workforce management services are designed for business use and are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13, and our terms of service explicitly prohibit use by minors. If we become aware that we have collected personal information from a child under 13, we will take immediate steps to delete that information from our systems. Parents or legal guardians who believe their child may have provided personal information to us can contact our privacy team, and we will promptly investigate and take appropriate action to protect the child's privacy.",
    },
    {
      title: "Updates to This Privacy Policy",
      content:
        "We may update this privacy policy periodically to reflect changes in our practices, technology, legal requirements, or other factors. When updates are made, we will post the revised policy on this page with an updated effective date clearly displayed. For significant changes that materially affect your rights or how we process your data, we will provide additional notice through email notifications or prominent announcements within our service. Your continued use of our services after any updates constitutes acceptance of the revised terms. We encourage you to review this privacy policy regularly to stay informed about how we protect your information.",
    },
  ];

  return (
    <Box sx={{ backgroundColor: "#F3F9FF", mt: isMobile ? 11 : 9 }}>
      {/* Hero Section */}

      {/* Privacy Content Sections */}
      <Box sx={{ backgroundColor: "white", py: isMobile ? 6 : 8 }}>
        <Container maxWidth="lg">
          <Box sx={{ px: isMobile ? 2 : 4 }}>
            <Box sx={{ mb: 5 }}>
              <CustomText
                style={{
                  ...textStyles.h1,
                  marginBottom: isMobile ? "0rem" : "1rem",
                  marginTop: isMobile ? "0rem" : "1rem",
                  fontSize: isMobile ? "36px" : "52px",
                  textAlign: isMobile ? "center" : "left",

                  // maxWidth:"400px"
                }}
              >
                Terms and Conditions
              </CustomText>
              <CustomText
                style={{
                  ...textStyles.body2,
                  color: "#5E5C5C",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "left",
                  // marginBottom: "2rem",

                  // maxWidth:"400px"
                }}
              >
                Last updated: May 29, 2025{" "}
              </CustomText>
              <CustomText
                style={{
                  ...textStyles.body2,
                  color: "#5E5C5C",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "left",
                  marginBottom: "2rem",

                  // maxWidth:"400px"
                }}
              >
                This Privacy Policy describes Our policies and procedures on the
                collection, use and disclosure of Your information when You use
                the Service and tells You about Your privacy rights and how the
                law protects You.
                <br /> We use Your Personal data to provide and improve the
                Service. By using the Service, You agree to the collection and
                use of information in accordance with this Privacy Policy.{" "}
              </CustomText>
            </Box>
            {privacyData.map((section, index) => (
              <Box key={index} sx={{ mb: 5 }}>
                <CustomText
                  style={{
                    ...textStyles.h3,
                    color: "#072533",
                    marginBottom: "1.5rem",
                    fontSize: isMobile ? "24px" : "28px",
                    fontWeight: 600,
                    textAlign: "left",
                  }}
                >
                  {section.title}
                </CustomText>

                <CustomText
                  style={{
                    ...textStyles.body2,
                    color: "#5E5C5C",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "left",
                    marginBottom: "2rem",
                  }}
                >
                  {section.content}
                </CustomText>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Cookies;
